import React, { useEffect } from 'react';
import { trackScroll, trackPageView, trackThemeToggle } from './Analytics';

const AnalyticsTracker = ({ pageTitle, pageLocation, darkMode }) => {
  useEffect(() => {
    // Track page view cuando el componente se monta
    if (pageTitle && pageLocation) {
      trackPageView(pageTitle, pageLocation);
    }
  }, [pageTitle, pageLocation]);

  useEffect(() => {
    // Track theme toggle
    if (darkMode !== undefined) {
      trackThemeToggle(darkMode ? 'dark' : 'light');
    }
  }, [darkMode]);

  useEffect(() => {
    // Track scroll events
    let scrollTimeout;
    
    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollPercentage = Math.round((scrollY / (documentHeight - windowHeight)) * 100);
        
        // Track scroll milestones
        if (scrollPercentage >= 25) trackScroll('25%');
        if (scrollPercentage >= 50) trackScroll('50%');
        if (scrollPercentage >= 75) trackScroll('75%');
        if (scrollPercentage >= 90) trackScroll('90%');
      }, 100);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  // Este componente no renderiza nada, solo maneja tracking
  return null;
};

export default AnalyticsTracker; 